import React from 'react';
import { useDragLayer } from 'react-dnd';
import { ItemTypes } from 'constants/itemTypes';
import { Icon } from 'ui';
import Text from 'components/shared/Text';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};
function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }
  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}
export const CustomDragLayer = props => {
  const { itemType, isDragging, item, initialOffset, currentOffset } =
    useDragLayer(monitor => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }));
  const RenderPreview = ({ previewItem }) => (
    <div className="h-56 w-fill bdrs-2 d-f jc-sb ai-c border-solid border-1 f-o-n mt-8 ta-l OnDemandPracticeConversation-interactionHeader--dragPreview pr-8 pl-8 bg-teal-lightest border-teal-lightest">
      <div className="f-o-n u-resetBtn">
        <Icon name="bars" className="fz-20 c-gray-darker h-c-gray-darkest" />
      </div>
      <span className="w-fill d-f">
        <span className="fz-16 fw-b ml-8 mr-8 ws-nw o-h">{`${t(
          'practice.on_demand_practice.editor.conversations.interaction_header',
        )} ${previewItem.position}`}</span>
        <Text lines={1} className="fz-16">
          - {previewItem.subject}
        </Text>
      </span>
    </div>
  );
  function renderItem() {
    switch (itemType) {
      case ItemTypes.INTERACTION:
        return <RenderPreview previewItem={item} />;
      default:
        return null;
    }
  }
  if (!isDragging) {
    return null;
  }
  return (
    <div style={layerStyles}>
      <div style={getItemStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </div>
    </div>
  );
};
